import './academic-transparency-banner.style.scss'

const AcademicTransparencyBanner = () => {
  return (
    <p className="academic-transparency-banner" role="note">
      {
        'Dados de uso podem ser coletados de forma an\u00f4nima, exclusivamente para fins acad\u00eamicos.'
      }
    </p>
  )
}

export { AcademicTransparencyBanner }
